import * as React from "react";
import { forwardRef } from "react";
const SvgArrowIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M-2.22261e-07 5.5762L10.3814 5.5762L5.9322 1.12705L6.49153 0.491455L12 5.99993L6.49152 11.5084L5.9322 10.8728L10.3814 6.42366L-2.59305e-07 6.42366L-2.22261e-07 5.5762Z", fill: "#A5A5AE" }));
const ForwardRef = forwardRef(SvgArrowIcon);
export { ForwardRef as ReactComponent };
